import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';

const PlansList = lazy(() =>
    import('../../pages/Plan').then((module) => ({
        default: module.PlansList,
    }))
);

export function PlansContainer() {
    return (
        <Routes>
            <Route
                path={'*'}
                element={
                    <LazyLoadComponent type="LIST" Component={<PlansList />} />
                }
            />
        </Routes>
    );
}
